import config from '@/common/config';
import _ from '@/common/helpers';

/**
 * Meta Guards for setting title and meta tags.
 */
export default class MetaGuard {
    /**
     * First word in the page title
     * @type {string}
     */
    static applicationTitle = config.VUE_APP_APPLICATION_TITLE;

    /**
     * Creates the page title
     * from the meta in the route
     * @param {RouteConfig} route
     * @param {Object} route.meta
     * @return {string}
     */
    static titleFromMeta({meta}) {
        if (meta && meta.title) {
            const pageTitle = _.unKebabCase(_.capitalize(meta.title));
            return `${MetaGuard.applicationTitle} - ${pageTitle}`;
        }
        return MetaGuard.applicationTitle;
    }

    /**
     * Middleware that process the page title
     * from the requested route
     * @param {RouteConfig} to
     */
    static middleware(to) {
        document.title = MetaGuard.titleFromMeta(to);
    }
}
